import React from 'react';
import { Button, Card, CardGroup, Col, Row } from 'react-bootstrap';
import image1 from '../images/a.png'
import image2 from '../images/t1.png'
import image3 from '../images/m1.png'
import school from '../images/school.png'
import ecommerce1 from '../images/ecommerce1.png'


const AllProjects = () => {
    return (
        <div className="container mt-4" style={{ width: '60%', paddingBottom: '60px' }}>
            <div className=" my-3 py-4">
                <h2>My Projects</h2>
                <hr style={{ width: '5%', backgroundColor: '#64ffda', fontWeight: '800', height: '2px', marginTop: '7px' }} />
            </div>
            <CardGroup>
                <Row xs={1} md={3} className="g-5">
                    <Col>
                        <Card style={{ height: '550px' }}>
                            <Card.Img variant="top" src={ecommerce1} style={{ height: '175px' }} />
                            <Card.Body>
                                <Card.Title className="text-black">E-commerce website</Card.Title>
                                <Card.Text className="text-black">
                                    This is a dynamic E-commerce website that has our daily necessary goods. After login, user can buy a products and can give review for this application. In admin panel, admin can manage all products and orders and also can make admin anyone.
                                </Card.Text>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">React.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Node.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Express.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">MongoDB</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Tailwind CSS</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Firebase</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Redux toolkit</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Axios</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Heroku</Button>

                                <div className="mt-3">
                                    <span> <a style={{ color: 'black', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://github.com/aktarinaakhi/e-commerce-website-client"><i style={{ fontSize: '25px' }} className="fab fa-github-square"></i></a></span>

                                    <span> <a style={{ color: 'black', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://e-commerce-website-b91ec.web.app/"><i style={{ fontSize: '20px' }} className="fas fa-external-link-alt"></i></a></span>
                                </div>
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ height: '550px' }}>
                            <Card.Img variant="top" src={image1} style={{ height: '175px' }} />
                            <Card.Body>
                                <Card.Title className="text-black">Moto Bike Store</Card.Title>
                                <Card.Text className="text-black">
                                    A dynamic bike store website where users can order any product after login and can view their ordered products after placing the order and can place review. Admin can add and delete products.
                                </Card.Text>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">React.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Node.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Express.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">MongoDB</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Bootstarp4</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Firebase</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Axios</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Heroku</Button>

                                <div className="mt-3">
                                    <span> <a style={{ color: 'black', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://github.com/aktarinaakhi/bike-selling-server"><i style={{ fontSize: '25px' }} className="fab fa-github-square"></i></a></span>

                                    <span> <a style={{ color: 'black', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://bike-selling-client.web.app/"><i style={{ fontSize: '20px' }} className="fas fa-external-link-alt"></i></a></span>
                                </div>
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ height: '550px' }}>
                            <Card.Img variant="top" src={image2} style={{ height: '175px' }} />
                            <Card.Body>
                                <Card.Title className="text-black">Hotel Booking</Card.Title>
                                <Card.Text className="text-black">
                                    Tourism can see about so many hotel and also can book a hotel as their preferred place. Admin can shifted their order and then they can inform others guidlines about this hotel and place.
                                </Card.Text>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">React.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Node.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Express.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">MongoDB</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Bootstarp4</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Firebase</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Heroku</Button>

                                <div className="mt-3">
                                    <span> <a style={{ color: 'black', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://github.com/aktarinaakhi/tourism-booking-website"><i style={{ fontSize: '25px' }} className="fab fa-github-square"></i></a></span>

                                    <span> <a style={{ color: 'black', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://tourism-assignment-11.web.app/"><i style={{ fontSize: '20px' }} className="fas fa-external-link-alt"></i></a></span>
                                </div>
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ height: '550px' }}>
                            <Card.Img variant="top" src={image3} style={{ height: '175px' }} />
                            <Card.Body>
                                <Card.Title className="text-black">Medicare Centre</Card.Title>
                                <Card.Text className="text-black">
                                    Medicare center provides lots of services that related with doctor and paitents. Paitents can know about so many test with cost of this diagonostics. Also can get appoinments of doctors. Sign-in and Sign Up implemented using firebase.
                                </Card.Text>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">React.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Node.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Express.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">MongoDB</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Bootstarp4</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Firebase</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Heroku</Button>

                                <div className="mt-3">
                                    <span> <a style={{ color: 'black', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://github.com/aktarinaakhi/medicare-center"><i style={{ fontSize: '25px' }} className="fab fa-github-square"></i></a></span>

                                    <span> <a style={{ fontSize: '30px', color: 'black', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://medicare-center.web.app/"><i style={{ fontSize: '20px' }} className="fas fa-external-link-alt"></i></a></span>
                                </div>
                            </Card.Body>

                        </Card>
                    </Col>
                    <Col>
                        <Card style={{ height: '550px' }}>
                            <Card.Img variant="top" src={school} style={{ height: '175px' }} />
                            <Card.Body>
                                <Card.Title className="text-black">Modern School</Card.Title>
                                <Card.Text className="text-black">
                                    There has lots of courses, student can buy a course as their skills. This course will be paid or unpaid and offline or online. They can connec with course teacher and advisor to get better suggetions.
                                </Card.Text>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">React.js</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Bootstarp4</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">react-router-dom</Button>
                                <Button className="me-1 mt-2" variant="secondary" size="sm">Axios</Button>


                                <div className="mt-3">
                                    <span> <a style={{ fontSize: '-10px', color: 'black', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://github.com/aktarinaakhi/modern-schooling"><i style={{ fontSize: '25px' }} className="fab fa-github-square"></i></a></span>

                                    <span> <a style={{ fontSize: '30px', color: 'black', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://modern-schooling9.netlify.app/"><i style={{ fontSize: '20px' }} className="fas fa-external-link-alt"></i></a></span>
                                </div>
                            </Card.Body>

                        </Card>
                    </Col>

                </Row>

            </CardGroup>
        </div>
    );
};

export default AllProjects;